import React from 'react';
import { useTranslation, Trans } from 'react-i18next'; 

import { Link } from 'react-router-dom';
import kittenImage from '../assets/images/NotFound.webp'; 
import '../styles/App.css'; 
import logo from '../assets/images/bwossy-logo.svg';
import BwossyLogo from "../components/Layout/BwossyLogo"; 

const NotFound = () => {
  const { t } = useTranslation(); 

  return (
    <div className="not-found-container">
      <div className="login-logo-container">
        <a href="./">
          <span className="login-logo-name">
            <Trans i18nKey="common.appNameLogo" components={[<BwossyLogo />]} />
          </span>
        </a>
      </div>

        <div className="not-found-content-container">

          <h2 className="not-found-title">{t('notFound.pageTitle')}</h2>

          <p>{t('notFound.notFoundText')}</p>
          {/*<img src={kittenImage} alt={t('imageAltText')} className="kitten-image" />*/}
          

          <Link to="/">
            <div className="outer-circle">
              <div className="inner-circle"><span>{t('notFound.homeButton')}</span></div>
            </div>
          </Link>
        
        </div>
    </div>
  );
};

export default NotFound;
